import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Invoice_header from '../Header/Invoice_header';
import "../../styles/InvoiceEdit.css";
import back_arrow from "../../assets/svg/back-arrow.svg";
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import axios from 'axios';
import "../../styles/invoice_addnew.css";
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from '../../axiosInstance';
import tick_icon from "../../assets/svg/tick_icon.svg"
import submitted_icon from "../../assets/svg/approval-flow-submitted-icon.svg"
import cancel_icon from "../../assets/svg/approval-flow-cancel-icon.svg"
import deleted_icon from "../../assets/svg/approval-flow-deleted-icon.svg"
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonFooter from '../../CommonFooter/CommonFooter';
import useAttachmentValidator from "../AttachmentValidator/AttachmentValidator";
import { HiOutlineDownload } from 'react-icons/hi';
import ApproveRejectPopup from './ApproveRejectPopup';
import { SquarePen } from "lucide-react";
import CommonRemarkPopup from '../../CommonRemarkPopup/CommonRemarkPopup';
import SapCsvSafeInput from '../../CommonRemarksRestriction/SapCsvSafeInput';

const SalesInvoiceViewPage = () => {

    let ModuleId = 24
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);
    const { validateAttachments } = useAttachmentValidator();
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const invoice = state?.invoice || {};
    const isCancelledInvoice = state?.isCancelledInvoice || false;
    const [allCategories, setAllCategories] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [sapDetails, setSapDetails] = useState({});
    const [jobTypes, setJobTypes] = useState([]);
    const [summary, setSummary] = useState([]);
    const [isDraft, setIsDraft] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [projectId, setselectedprojectId] = useState(0);
    const [selectedChargeIds, setSelectedChargeIds] = useState({});
    const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
    const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
    const [inputValues, setInputValues] = useState({});
    const [activeTab, setActiveTab] = useState('jobs'); // Default to 'jobs' ta
    const [showTimeline, setShowTimeline] = useState(true);
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [actionType, setActionType] = useState(""); // 'approved' or 'rejected'
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState('');
    const [salesHeaderRemarks, setSalesHeaderRemarks] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [backdatedDate, setBackdatedDate] = useState('');
    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');
    const [billingNature, setBillingNature] = useState("");
    const [supplyPeriod, setSupplyPeriod] = useState(null);
    const [approvalData, setApprovalData] = useState(null);
    const [showRemarkPopup, setShowRemarkPopup] = useState(false);
    const [remarkValue, setRemarkValue] = useState("");
    const [remarkMeta, setRemarkMeta] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isApproveLoading, setIsApproveLoading] = useState(false);
    const [ffPlantCode, setFfPlantCode] = useState(null);
    const [divisionType, setDivisionType] = useState(null);

    const openModal = async (type) => {
        setActionType(type);

        const data = await fetchApprovalData(invoice.id);

        if (data) {
            setApprovalData(data);
            setModalOpen(true);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setApprovalData(null);
    };

    const convertToInputDateFormat = (dateString) => {
        if (!dateString) return '';
        const [day, month, year] = dateString.split('-');
        return `${year}-${month}-${day}`;
    };

    const getMinBackdatedDate = (dateStr, days) => {
        const baseDate = new Date(dateStr);
        baseDate.setDate(baseDate.getDate() - days);
        return baseDate.toISOString().split('T')[0];
    };



    useEffect(() => {
        const fetchInvoiceData = async () => {
            if (invoice.id) {
                // setIsLoading(true);
                try {
                    let response;

                    if (isCancelledInvoice) {
                        // Fetch cancelled invoice data
                        response = await axiosInstance.get(
                            `/invoice/cancelled_invoice_view/${invoice.id}`
                        );
                        console.log("Cancelled Invoice Response:", response.data);
                    } else {
                        response = await axiosInstance.get(
                            `invoice/edit_sales_invoice/${invoice.id}`
                        );
                        console.log("Regular Invoice Response:", response.data);
                    }
                    console.log("Invoice Response Edit Data", response.data);

                    if (response.data && response.data.success) {
                        const data = response.data.data;

                        console.log("Fetched invoice_details", data.invoice_details);
                        console.log("Fetched summary", data.summary);
                        console.log("Fetched line_items", data.line_items);
                        console.log("Fetched sap_details", data.sap_details);
                        console.log("invoice details.created_date", data.invoice_details[0]?.created_date);


                        setInvoiceDetails(data.invoice_details[0] || {});
                        setSapDetails(data.sap_details[0] || {});
                        setJobTypes(data.job_types || []);
                        setSummary(data.summary || []);
                        const supplyPeriodFromApi = data.line_items?.[0]?.supply_period;

                        if (supplyPeriodFromApi) {
                            const [month, year] = supplyPeriodFromApi.split("-");
                            const date = new Date(`${month} 1, ${year}`);
                            setSupplyPeriod(date);
                        }

                        if (data.summary && data.summary.length > 0) {
                            setFfPlantCode(data.summary[0]?.ff_plant_id || null);
                            setDivisionType(data.summary[0]?.division_type?.toLowerCase() || null);
                        }
                        setselectedprojectId(data.invoice_details[0]?.project_id);
                        setApprovalHistory(data.approval_history || []);
                        if (data.invoice_details[0]?.backdated_date) {
                            const apiBackdatedDate = new Date(data.invoice_details[0].backdated_date);
                            setBackdatedDate(apiBackdatedDate);
                        }

                        // Calculate date range
                        const apiDate = data.invoice_details[0]?.created_date;
                        const backDays = parseInt(data.invoice_details[0]?.backdated_days || '0');
                        const formattedDate = convertToInputDateFormat(apiDate);
                        setMaxDate(formattedDate);
                        setMinDate(getMinBackdatedDate(formattedDate, backDays));
                        // Transform line items for sales invoice
                        const transformedCategories = data.line_items.map(item => {
                            const jobIdFromDetails = item.details.find(detail => detail.job_id)?.job_id || '';
                            const jobTypeFromDetails = item.details.find(detail => detail.job_type)?.job_type || '';
                            const quantityFromDetails = item.details.find(detail => detail.sales_unit_of_quantity)?.sales_unit_of_quantity || '0';
                            const jobtypeidFromDetails = item.details.find(detail => detail.job_type_id)?.job_type_id || '0';
                            return {
                                jobnumber: item.job_no,
                                id: jobIdFromDetails,
                                jobTypeId: jobtypeidFromDetails,
                                jobType: jobTypeFromDetails,
                                quantity: quantityFromDetails,
                                rows: item.details.map(detail => ({
                                    chargecode: detail.charge_code || "",
                                    description: detail.description || "",
                                    // unitQuantity: detail.unit_of_quantity || "",
                                    salesunitQuantity: detail.sales_unit_of_quantity || "",
                                    jobTypeId: detail.job_type_id || 0,
                                    jobLineId: detail.job_line_id || 0,
                                    chargeId: detail.charge_id || 0,
                                    attachment: detail.attachment_url || "",
                                    existingAttachmentUrl: detail.attachment_url || "",
                                    uploadedFiles: [],
                                    supporting_document: detail.sales_supporting_doc ?? false,
                                    isChecked: false,
                                    salesRemarks: detail.sales_remarks || "",
                                    salesAccrual: detail.sales_accrual || "",
                                    salesRate: detail.sales_unit_of_rate || "",
                                    salesNetTotal: detail.sales_net_total || "",
                                    salesContractValue: detail.sales_contract_value || 0,
                                    po_wo_number: detail.sales_po_wo_number || null,
                                    po_wo_date: detail.sales_po_wo_date || null
                                }))

                            };
                        });

                        setAllCategories(transformedCategories);

                        // Initialize input values
                        const initialInputValues = {};
                        transformedCategories.forEach((category, catIndex) => {
                            initialInputValues[catIndex] = {};
                            category.rows.forEach((row, rowIndex) => {
                                initialInputValues[catIndex][rowIndex] = row.chargecode || "";
                            });
                        });
                        setInputValues(initialInputValues);

                        // Initialize selected charge IDs
                        const initialSelectedChargeIds = {};
                        transformedCategories.forEach((category, catIndex) => {
                            category.rows.forEach((row, rowIndex) => {
                                initialSelectedChargeIds[`${catIndex}_${rowIndex}`] = row.chargeId || 0;
                            });
                        });
                        setSelectedChargeIds(initialSelectedChargeIds);

                        // Set status flags
                        const status = data.invoice_details[0]?.approval_status?.toLowerCase();
                        setIsDraft(status === 'draft' || status === 'rejected');
                        setIsSubmitted(status === 'submitted' || status === 'approved' || status === 'completed' || status === 'rejected' || status === 're-submitted' || status === 'sap pushed' || status === 'final invoice' || status === 'cancelled' || status === 'deleted' || status === 'cancel submitted');
                    }
                } catch (error) {
                    console.error("Error fetching invoice data:", error);
                }
                // finally {
                //     setIsLoading(false);
                // }
            }
        };

        fetchInvoiceData();
    }, [invoice]);


    const isDateEnabled = (date) => {
        if (!invoiceDetails.created_date || !invoiceDetails.backdated_days) return false;

        const backdatedDays = parseInt(invoiceDetails.backdated_days);
        const createdDate = new Date(convertToInputDateFormat(invoiceDetails.created_date));
        const inputDate = new Date(date);

        const oldestAllowedDate = new Date(createdDate);
        oldestAllowedDate.setDate(createdDate.getDate() - backdatedDays);

        return inputDate >= oldestAllowedDate && inputDate <= createdDate;
    };

    const addRow = (categoryId) => {
        if (!isDraft) return; // Only allow adding rows for draft invoices

        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: [
                            ...category.rows,
                            {
                                billingtype: "",
                                jobTypeId: category.rows[0]?.jobTypeId || "",
                                chargecode: "",
                                elements: "",
                                description: "",
                                jobLineId: "",
                                // unitQuantity: "",
                                salesunitQuantity: "",
                                salesRemarks: "",
                                salesAccrual: "",
                                salesRate: "",
                                salesNetTotal: "",
                                po_wo_number: null,
                                po_wo_date: null,
                                salesContractValue: "0",
                                attachment: "",
                                uploadedFiles: [],
                                isChecked: false
                            },
                        ],
                    }
                    : category
            )
        );
    };

    const handleFileUpload = (e, categoryId, index, lineindex) => {
        const files = validateAttachments(e.target.files);
        if (!files.length) return;

        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] } : row
                        ),
                    }
                    : category
            )
        );
    };

    const handleRemoveFile = (categoryId, index, lineindex, fileIndex) => {
        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex
                                ? {
                                    ...row,
                                    uploadedFiles: row.uploadedFiles.filter((_, index) => index !== fileIndex),
                                }
                                : row
                        ),
                    }
                    : category
            )
        );
    };

    const handleRemoveAttachment = (categoryId, index, lineindex) => {
        setAllCategories(prevCategories =>
            prevCategories.map(category =>
                category.id === categoryId
                    ? {
                        ...category,
                        rows: category.rows.map((row, i) =>
                            i === lineindex
                                ? {
                                    ...row,
                                    attachment: "",
                                    existingAttachmentUrl: "",
                                    uploadedFiles: []
                                }
                                : row
                        ),
                    }
                    : category
            )
        );
    };



    // const handleInputChange = (e, categoryId, rowIndex, field) => {
    //    // Only allow input changes for draft invoices

    //     const { value } = e.target;

    //     setAllCategories(prevCategories =>
    //         prevCategories.map(category =>
    //             category.id === categoryId
    //                 ? {
    //                     ...category,
    //                     rows: category.rows.map((row, i) => {
    //                         if (i === rowIndex) {
    //                             const updatedRow = { ...row, [field]: value };

    //                             if (field === 'unitQuantity' || field === 'unitRatePrice') {
    //                                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
    //                                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
    //                                 updatedRow.netTotal = (quantity * rate).toString();
    //                             }

    //                             return updatedRow;
    //                         }
    //                         return row;
    //                     }),
    //                 }
    //                 : category
    //         )
    //     );
    // };

    const handleInputChange = (e, index, rowIndex, field) => {
        if (!isDraft) return;
        let value = e.target.value;

        if (field === "salesRemarks") {
            value = value.replace(/,/g, "");
        }

        setAllCategories(prevCategories =>
            prevCategories.map((category, currentindex) => {
                if (currentindex === index) {
                    const updatedRows = category.rows.map((row, i) => {
                        if (i === rowIndex) {
                            const updatedRow = { ...row, [field]: value };

                            // Recalculate values when relevant fields change
                            if (field === 'salesunitQuantity' || field === 'salesRate') {
                                const Salesquantity = parseFloat(updatedRow.salesunitQuantity) || 0;
                                const salesRate = parseFloat(updatedRow.salesRate) || 0;
                                updatedRow.salesNetTotal = (Salesquantity * salesRate).toFixed(2);
                            }

                            if (field === 'costunitQuantity' || field === 'costRate') {
                                const Costquantity = parseFloat(updatedRow.costunitQuantity) || 0;
                                const costRate = parseFloat(updatedRow.costRate) || 0;
                                updatedRow.costNetTotal = (Costquantity * costRate).toFixed(2);
                            }

                            // Calculate profit whenever sales or cost changes
                            if (field === 'salesRate' || field === 'costRate' ||
                                field === 'salesunitQuantity' || field === 'salesNetTotal' ||
                                field === 'costNetTotal') {
                                const salesTotal = parseFloat(updatedRow.salesNetTotal) || 0;
                                const costTotal = parseFloat(updatedRow.costNetTotal) || 0;
                                updatedRow.profitAmount = (salesTotal - costTotal).toFixed(2);
                                updatedRow.profitPercent = costTotal > 0
                                    ? (((salesTotal - costTotal) / costTotal) * 100).toFixed(2)
                                    : '0.00';
                            }

                            return updatedRow;
                        }
                        return row;
                    });

                    // Calculate category totals
                    const categoryTotals = updatedRows.reduce((acc, row) => {
                        return {
                            salesNetTotal: acc.salesNetTotal + (parseFloat(row.salesNetTotal) || 0),
                            costNetTotal: acc.costNetTotal + (parseFloat(row.costNetTotal) || 0),
                            profitAmount: acc.profitAmount + (parseFloat(row.profitAmount) || 0)
                        };
                    }, { salesNetTotal: 0, costNetTotal: 0, profitAmount: 0 });

                    const profitPercent = categoryTotals.costNetTotal > 0
                        ? ((categoryTotals.profitAmount / categoryTotals.costNetTotal) * 100).toFixed(2)
                        : '0.00';

                    return {
                        ...category,
                        rows: updatedRows,
                        salesNetTotal: categoryTotals.salesNetTotal.toFixed(2),
                        costNetTotal: categoryTotals.costNetTotal.toFixed(2),
                        profitAmount: categoryTotals.profitAmount.toFixed(2),
                        profitPercent
                    };
                }
                return category;
            })
        );
    };

    // const deleteRow = (categoryId, rowIndex) => {
    //     if (!isDraft) return; // Only allow row deletion for draft invoices

    //     setAllCategories(prevCategories =>
    //         prevCategories.map(category => {
    //             if (category.id === categoryId) {
    //                 const newRows = [...category.rows];
    //                 newRows.splice(rowIndex, 1);
    //                 return { ...category, rows: newRows };
    //             }
    //             return category;
    //         })
    //     );
    // };

    const deleteRow = (categoryId, rowIndex) => {
        const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

        if (categoryIndex === -1) {
            return; // Category not found, should not happen but good to check
        }

        const category = allCategories[categoryIndex];

        if (category.rows.length <= 1) {
            toast.error("At least one row must remain, cannot delete.");
            return;
        }

        setAllCategories(prevCategories =>
            prevCategories.map(cat => {
                if (cat.id === categoryId) {
                    const newRows = [...cat.rows];
                    newRows.splice(rowIndex, 1);
                    return { ...cat, rows: newRows };
                }
                return cat;
            })
        );

        setInputValues(prevInputValues => {
            const newInputValues = { ...prevInputValues };
            if (newInputValues[categoryIndex]) {
                const rows = { ...newInputValues[categoryIndex] };
                delete rows[rowIndex];
                const shiftedRows = {};
                Object.keys(rows).forEach(key => {
                    const keyNum = Number(key);
                    shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
                });
                newInputValues[categoryIndex] = shiftedRows;
            }
            return newInputValues;
        });

        setSelectedChargeIds(prevSelectedChargeIds => {
            const newSelectedChargeIds = {};
            Object.keys(prevSelectedChargeIds).forEach(key => {
                const [catIndexStr, rowIdxStr] = key.split('_');
                const catIndex = Number(catIndexStr);
                const rowIdx = Number(rowIdxStr);

                if (catIndex === categoryIndex) {
                    if (rowIdx < rowIndex) {
                        newSelectedChargeIds[key] = prevSelectedChargeIds[key];
                    } else if (rowIdx > rowIndex) {
                        newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
                    }
                    // If rowIdx === rowIndex, we simply skip it (the deleted row)
                } else {
                    newSelectedChargeIds[key] = prevSelectedChargeIds[key];
                }
            });
            return newSelectedChargeIds;
        });

        setSuggestionsMap(prev => {
            const newMap = { ...prev };
            if (newMap[categoryIndex]) {
                const rows = { ...newMap[categoryIndex] };
                delete rows[rowIndex];
                const shiftedRows = {};
                Object.keys(rows).forEach(key => {
                    const keyNum = Number(key);
                    shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
                });
                newMap[categoryIndex] = shiftedRows;
            }
            return newMap;
        });
    };
    const [ismodalOpen, setIsModalOpen] = useState(false);

    // const handleUpdate = async (actionType) => {
    //     if (!isDraft) return; // Only allow submission for draft invoices

    //     for (let category of allCategories) {
    //         for (let row of category.rows) {
    //             const { chargecode, description, unitQuantity, unitRatePrice, netTotal } = row;

    //             if (!chargecode || !chargecode.trim()) {
    //                 toast.error("Charge Code is required");
    //                 return;
    //             }

    //             if (!description || !description.trim()) {
    //                 toast.error("Description of Charges is required");
    //                 return;
    //             }

    //             if (!unitQuantity || isNaN(unitQuantity)) {
    //                 toast.error("Unit Quantity is required");
    //                 return;
    //             }

    //             if (!unitRatePrice || isNaN(unitRatePrice)) {
    //                 toast.error("Unit Rate Price is required");
    //                 return;
    //             }

    //             if (!netTotal || isNaN(netTotal)) {
    //                 toast.error("Net Total is required");
    //                 return;
    //             }

    //         }
    //     }

    //     try {
    //         const jobs = allCategories.map((category, categoryIndex) => ({
    //             id: category.id,
    //             jobnumber: category.jobnumber,
    //             project_id: parseInt(projectId) || 0,
    //             job_type_id: category.rows[0]?.jobTypeId || 0,
    //             job_created_date: new Date().toISOString().split("T")[0],
    //             job_line: category.rows.map((row, rowIndex) => {
    //                 const attachmentKey = `${categoryIndex}_${rowIndex}`;
    //                 const hasNewFile = row.uploadedFiles?.length > 0;

    //                 return {
    //                     project_id: parseInt(projectId) || 0,
    //                     job_type_id: row.jobTypeId || 0,
    //                     charge_id: Array.isArray(selectedChargeIds[`${categoryIndex}_${rowIndex}`])
    //                         ? selectedChargeIds[`${categoryIndex}_${rowIndex}`]
    //                         : [selectedChargeIds[`${categoryIndex}_${rowIndex}`] || row.chargeId || 0],
    //                     description_of_charges: row.description || "",
    //                     unit_of_quantity: parseFloat(row.unitQuantity) || 0,
    //                     unit_of_rate: parseFloat(row.unitRatePrice) || 0,
    //                     net_total: parseFloat(row.netTotal) || 0,
    //                     accrual: parseFloat(row.accrualSplit) || 0,
    //                     attachment_key: attachmentKey,
    //                     ...(hasNewFile
    //                         ? {}
    //                         : row.existingAttachmentUrl && { existing_attachment_url: row.existingAttachmentUrl }),
    //                 };
    //             })
    //         }));

    //         const payload = {
    //             jobs,
    //             actions: [actionType],
    //             update_invoice: "1",
    //             invoice_id: invoice.id,
    //             approval_status: invoice.approval_status
    //         };

    //         const formData = new FormData();
    //         formData.append("data", JSON.stringify(payload));

    //         allCategories.forEach((category, categoryIndex) => {
    //             category.rows.forEach((row, rowIndex) => {
    //                 if (row.uploadedFiles?.length > 0) {
    //                     row.uploadedFiles.forEach(file => {
    //                         const attachmentKey = `${categoryIndex}_${rowIndex}`;
    //                         formData.append(`attachments[${attachmentKey}][]`, file);
    //                     });
    //                 }
    //             });
    //         });

    //         // const response = await axios.post(
    //         //     'https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/save',
    //         //     formData,
    //         //     { headers: { 'Content-Type': 'multipart/form-data' } }
    //         // );

    //         const response = await axiosInstance.post(
    //             '/invoice/save',
    //             formData,
    //             { headers: { 'Content-Type': 'multipart/form-data' } }
    //         );

    //         if (response.data.success) {
    //             toast.success('Invoice updated successfully!');
    //             navigate(-1); // Go back to previous page
    //         } else {
    //             toast.error('Failed to update invoice: ' + (response.data.message || 'Unknown error'));
    //         }
    //     } catch (error) {
    //         console.error('Error updating invoice:', error);
    //         toast.error('An error occurred while updating the invoice');
    //     }
    // };






    const handleUpdate = async (action) => {
        if (!isDraft) return; // Only allow update for draft invoices
        if (isSaving || isSubmitting) return;

        // ✅ Validate all job line fields before proceeding
        for (let category of allCategories) {
            for (let row of category.rows) {
                const { chargecode, description, salesunitQuantity, salesRate, salesNetTotal } = row;

                if (!chargecode || !chargecode.trim()) {
                    toast.error("Charge Code is required");
                    return;
                }

                if (!description || !description.trim()) {
                    toast.error("Description of Charges is required");
                    return;
                }

                if (!salesunitQuantity || isNaN(salesunitQuantity)) {
                    toast.error("Unit Quantity is required");
                    return;
                }

                if (!salesRate || isNaN(salesRate)) {
                    toast.error("Unit Rate Price is required");
                    return;
                }

                if (!salesNetTotal || isNaN(salesNetTotal)) {
                    toast.error("Net Total is required");
                    return;
                }
            }
        }

        if (action === "save") {
            setIsSaving(true);
        } else {
            setIsSubmitting(true);
        }

        try {
            const jobs = allCategories.map((category, categoryIndex) => ({
                id: category.id,
                jobnumber: category.jobnumber,
                project_id: parseInt(projectId) || 0,
                job_type_id: category.rows[0]?.jobTypeId || 0,
                job_created_date: new Date().toISOString().split("T")[0],
                ff_plant_id: ffPlantCode,
                job_line: category.rows.map((row, rowIndex) => {
                    const attachmentKey = `${categoryIndex}_${rowIndex}`;
                    const hasNewFile = row.uploadedFiles?.length > 0;

                    return {
                        job_line_id: row.jobLineId || undefined, // ✅ Ensure it's passed for update
                        project_id: parseInt(projectId) || 0,
                        job_type_id: row.jobTypeId,
                        charge_id: selectedChargeIds[attachmentKey] || 0,
                        description_of_charges: row.description || "",
                        // unit_of_quantity: parseFloat(row.unitQuantity) || 0,
                        unit_of_quantity: parseFloat(row.salesunitQuantity) || 0,
                        unit_of_rate: parseFloat(row.salesRate) || 0,
                        net_total: parseFloat(row.salesNetTotal) || 0,
                        accrual: parseFloat(row.salesAccrual) || 0,
                        remarks: row.salesRemarks || "",
                        contract_value: parseFloat(row.salesContractValue) || 0,
                        po_wo_number: row.po_wo_number || null,
                        po_wo_date: row.po_wo_date || null,
                        attachment_keys: { sales: attachmentKey },
                        ...(hasNewFile
                            ? {}
                            : row.existingAttachmentUrl && {
                                existing_sales_attachment_url: row.existingAttachmentUrl,
                            }),
                    };
                }),
            }));

            const payload = {
                jobs,
                actions: [action],
                update_invoice: "1",
                invoice_id: invoice.id,
                invoice_target: 'sales',
                invoice_mode: 'combine',
                approval_status: invoice.approval_status,
                sales_header_remarks: salesHeaderRemarks,
                backdated_date: backdatedDate === "" ? null : backdatedDate,
                supply_period: supplyPeriod
                    ? supplyPeriod.toLocaleString("en-US", { month: "short" }) +
                    "-" +
                    supplyPeriod.getFullYear()
                    : null,
                billing_nature: billingNature || null,
                division_type: divisionType
            };

            const formData = new FormData();
            formData.append("data", JSON.stringify(payload));

            // ✅ Append uploaded files properly
            allCategories.forEach((category, categoryIndex) => {
                category.rows.forEach((row, rowIndex) => {
                    if (row.uploadedFiles?.length > 0) {
                        const attachmentKey = `${categoryIndex}_${rowIndex}`;
                        row.uploadedFiles.forEach((file) => {
                            formData.append(`attachments[${attachmentKey}][]`, file);
                        });
                    }
                });
            });

            const response = await axiosInstance.post(
                "/invoice/save",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data.success) {
                toast.success(
                    action === "submit"
                        ? "Sales Invoice submitted successfully!"
                        : "Sales Invoice updated successfully!"
                );
                navigate(-1);
            } else {
                toast.error("Failed to update invoice: " + (response.data.message || "Unknown error"));
            }
        } catch (error) {
            console.error("Error updating invoice:", error);
            toast.error("An error occurred while updating the invoice");
        } finally {
            setIsSaving(false);
            setIsSubmitting(false);
        }
    };




    // const handleApprove = async () => {
    //     try {
    //         // const response = await axios.post(
    //         //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/approve/${invoice.id}`
    //         // );

    //         const response = await axiosInstance.post(
    //             `/invoice/approve/${invoice.id}`
    //         );

    //         if (response.data.success) {
    //             alert('Invoice approved successfully!');
    //             navigate(-1);
    //         } else {
    //             alert('Failed to approve invoice: ' + (response.data.message || 'Unknown error'));
    //         }
    //     } catch (error) {
    //         console.error('Error approving invoice:', error);
    //         alert('An error occurred while approving the invoice');
    //     }
    // };

    // const handleReject = async () => {
    //     try {
    //         // const response = await axios.post(
    //         //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/reject/${invoice.id}`
    //         // );

    //         const response = await axiosInstance.post(
    //             `/invoice/reject/${invoice.id}`
    //         );

    //         if (response.data.success) {
    //             alert('Invoice rejected successfully!');
    //             navigate(-1);
    //         } else {
    //             alert('Failed to reject invoice: ' + (response.data.message || 'Unknown error'));
    //         }
    //     } catch (error) {
    //         console.error('Error rejecting invoice:', error);
    //         alert('An error occurred while rejecting the invoice');
    //     }
    // };



    const handleInvoiceAction = async (data) => {

        if (!data.comments?.trim()) {
            toast.error("Comment is required");
            return;
        }

        const payload = {
            invoice_id: invoice.id,
            project_id: invoiceDetails.project_id,
            module: "3",
            invoice_type: "sales",
            comments: data.comments,
            status: actionType,
            plant_code: data.plant_code,
            billing_nature: data.billing_nature,
            supply_period: data.supply_period,
            billing_date: data.billing_date,
            customer_remarks: data.customer_remarks,
            po_wo_number: data.po_wo_number,
            po_wo_date: data.po_wo_date
        };
        if (isApproveLoading) return;

        setIsApproveLoading(true);
        try {
            const response = await axiosInstance.post(`/approve_reject_btns`, payload);

            console.log("approve_reject response", response);

            if (response.status === 200) {
                toast.success(`Invoice ${actionType} successfully!`);
                navigate(-1);
            } else {
                toast.error(`Failed to ${actionType} invoice: ${response.data.message || 'Unknown error'}`);
            }

        } catch (error) {
            console.error(`Error ${actionType} invoice:`, error);
            toast.error(`An error occurred while ${actionType} the invoice`);
        } finally {
            setIsApproveLoading(false);
            closeModal();
        }
    };

    const calculateCategoryTotals = (category) => {
        const totals = {
            quantity: 0,
            rate: 0,
            netValue: 0
        };

        category.rows.forEach(row => {
            totals.quantity += parseFloat(row.unitQuantity) || 0;
            totals.rate += parseFloat(row.unitRatePrice) || 0;
            totals.netValue += parseFloat(row.netTotal) || 0;
        });

        return totals;
    };

    const fetchSuggestions = async (searchTerm = "", rowIndex, index) => {
        try {
            setSuggestionsMap([]);

            // const response = await axios.get(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${projectId}`,
            //     {
            //         params: {
            //             term: searchTerm
            //         }
            //     }
            // );

            const response = await axiosInstance.get(
                `/getnonprojectsaleschargecodes`,
                {
                    params: {
                        term: searchTerm
                    }
                }
            );

            if (response.data?.chargecodes) {

                const newSuggestions = response.data?.chargecodes || [];
                setSuggestionsMap(prev => {
                    const updated = { ...prev };
                    if (!updated[index]) updated[index] = {}; // initialize if empty
                    updated[index][rowIndex] = newSuggestions;
                    console.log("Updated suggestionsMap:", updated);
                    return updated;
                });

                setShowSuggestionsMap(prev => ({
                    ...prev,
                    [`${index}_${rowIndex}`]: true,
                }));
            }
        } catch (err) {
            console.error("Failed to fetch suggestions", err);

            setSuggestionsMap(prev => {
                const updated = { ...prev };
                if (!updated[index]) updated[index] = {};
                updated[index][rowIndex] = []; // clear only that one
                return updated;
            });

            setShowSuggestionsMap(prev => ({
                ...prev,
                [`${index}_${rowIndex}`]: false,
            }));
        }
    };

    const handleDownload = async (attachmentUrl) => {
        try {
            // Check if the URL is valid
            if (!attachmentUrl) {
                toast.error("No attachment available");
                return;
            }

            // Create a temporary anchor element
            const link = document.createElement('a');
            link.href = attachmentUrl;

            // Extract filename from URL or use a default name
            const fileName = attachmentUrl.split('/').pop() || 'document';
            link.setAttribute('download', fileName);

            // Append to DOM, trigger click, then remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
            toast.error('Failed to download file');
        }
    };

    const handleConsolidatedSalesAttachment = async () => {
        try {
            const response = await axiosInstance.post(
                "/invoice_consolidate_pdf",
                {
                    id: invoice.id,
                    attachment_type: "sales",
                }
            );

            if (response.data.status === "success") {
                window.open(response.data.file_url, "_blank");
            } else {
                toast.error(response.data.message || "Failed to fetch Sales PDF");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to download Consolidated Sales PDF");
        }
    };

    const fetchApprovalData = async (invoiceId) => {
        try {
            const response = await axiosInstance.post('/invoice/inv_approval_data', {
                invoice_id: invoiceId
            });

            if (response.data?.success) {
                return response.data.data;
            } else {
                toast.error(response.data?.message || "Failed to fetch approval data");
                return null;
            }
        } catch (error) {
            console.error("Approval data error:", error);
            toast.error("Error fetching approval data");
            return null;
        }
    };

    if (!showTimeline) return null;

    const openRemarkPopup = (rowIndex, lineIndex, value) => {
        setRemarkMeta({ rowIndex, lineIndex });
        setRemarkValue(value || "");
        setShowRemarkPopup(true);
    };

    const handleSaveRemark = (updatedValue) => {
        if (!remarkMeta) return;

        const { rowIndex, lineIndex } = remarkMeta;

        handleInputChange(
            { target: { value: updatedValue } },
            rowIndex,
            lineIndex,
            "salesRemarks"
        );

        setShowRemarkPopup(false);
    };

    return (
        <>
            <Invoice_header onSearch={null} disableSearch={true} />
            <div className='invoice_module'>
                <div className="invoice-module-header">
                    <div className="invoice-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }}
                        />
                        <p className="new_job">{invoice.inv_number}</p>
                    </div>
                    <div className="invoice-module_header_right">
                        {/* {!isDraft && (
                            <button className="edit_btn" onClick={() => navigate(-1)} >
                                Cancel
                            </button>
                        )} */}
                        {isDraft && (
                            <>
                                {/* <button className="edit_btn" onClick={() => navigate(-1)}>
                                    Cancel
                                </button> */}
                                <button className="edit_btn" onClick={() => handleUpdate("save")} disabled={isSaving || isSubmitting}>
                                    {isSaving ? "Saving..." : "Save"}
                                </button>
                                <button className="edit_btn" onClick={() => setIsModalOpen(true)} disabled={isSaving || isSubmitting}>
                                    Submit
                                </button>
                            </>
                        )}
                        {isSubmitted && invoiceDetails.approve_reject_btn === true && (
                            <>
                                <button className="reject_btn" onClick={() => openModal('rejected')}>
                                    Reject
                                </button>
                                <button className="approve_btn" onClick={() => openModal('approved')}>
                                    Approve
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className='invoice-module-details'>
                    <div className='invoice-module-job-details'>
                        <p className='invoice-module-invoice-details-header'>Invoice details</p>
                        <div className='invoice-module-main-details-grid' style={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}>
                            <div className='invoice-module-details-grid'>
                                <p className='invoice-module-invoice-details-label'>Invoice No</p>
                                <p className='invoice-module-invoice-details-value'>{invoiceDetails.inv_number}</p>

                                <p className='invoice-module-invoice-details-label'>Project</p>
                                <p className='invoice-module-invoice-details-value'>{invoice.project}</p>

                                <p className='invoice-module-invoice-details-label'>Period</p>
                                <p className='invoice-module-invoice-details-value'>Monthly</p>

                                <p className='invoice-module-invoice-details-label'>Created Date</p>
                                <p className='invoice-module-invoice-details-value'>{invoiceDetails.created_date}</p>

                                <p className='invoice-module-invoice-details-label'>Status</p>
                                <p className='invoice-module-invoice-details-value'>
                                    <span className={`status-badge ${invoice.approval_status}`}>
                                        {invoice.approval_status}
                                    </span>
                                </p>

                                {!["draft", "submitted"].includes(invoice.approval_status?.toLowerCase()) && (
                                    <>
                                        <p className='invoice-module-invoice-details-label'>Plant Code</p>
                                        <p className='invoice-module-invoice-details-value'>
                                            {invoiceDetails.plant_code || '-'}
                                        </p>
                                    </>
                                )}


                                <p className='invoice-module-invoice-details-label'>Supply Period</p>
                                <p className='invoice-module-invoice-details-value'>
                                    {invoiceDetails.supply_period ?? "-"}
                                </p>

                            </div>


                            {["draft", "rejected", "sap pushed"].includes(invoice.approval_status?.toLowerCase()) && (
                                <>
                                    <div style={{ borderLeft: '1px solid #ddd', margin: '0 20px' }}></div>

                                    <div className='invoice-module-details-grid' >
                                        <p className='invoice-module-invoice-details-label'>Remarks</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.sales_header_remarks ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Billing Nature</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.billing_nature ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>

                                    </div>
                                </>
                            )}


                            {invoice.approval_status?.toLowerCase() === 'submitted' && (
                                <>
                                    <div style={{ borderLeft: '1px solid #ddd', margin: '0 20px' }}></div>

                                    <div className='invoice-module-details-grid' >
                                        <p className='invoice-module-invoice-details-label'>Remarks</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.sales_header_remarks ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Billing Nature</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.billing_nature ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Billing Date</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.billing_date ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                        <p className='invoice-module-invoice-details-label'></p>
                                        <p className='invoice-module-invoice-details-value'></p>
                                    </div>
                                </>
                            )}

                            {invoice.approval_status?.toLowerCase() === 'final invoice' && (
                                <>
                                    <div style={{ borderLeft: '1px solid #ddd', margin: '0 20px' }}></div>

                                    <div className='invoice-module-details-grid' >
                                        <p className='invoice-module-invoice-details-label'>Remarks</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.sales_header_remarks ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Billing Nature</p>
                                        <p className='invoice-module-invoice-details-value'>{invoiceDetails.billing_nature ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>SAP Doc Number</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.sap_doc_no ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>ODN Number</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.odn_number ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>Bill Gross Amount</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.bill_gross_amount ?? "-"}</p>

                                        <p className='invoice-module-invoice-details-label'>SAP Invoice Date</p>
                                        <p className='invoice-module-invoice-details-value'>{sapDetails.sap_invoice_date ?? "-"}</p>
                                    </div>
                                </>
                            )}
                        </div>



                        <div className='invoice-module-job-types'>
                            <div className='job-types-content'>
                                <p className='invoice-module-invoice-details-header'>Job types - {jobTypes.length}</p>
                                <div className='job-types-buttons'>
                                    {jobTypes.map((jobType, index) => (
                                        <button key={index} className='invoice-module-invoice-details-data'>
                                            {jobType.job_type_name}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="invoice_module_project">
                            <div className="invoice-module-project-summary">
                                <p className="invoice-module-summary-summary">Summary</p>
                                <table className="invoice-module-summary-table">
                                    <thead>
                                        <tr>
                                            <th>Jobs</th>
                                            <th>Quantity</th>
                                            <th>Rate</th>
                                            <th>Net Value</th>
                                        </tr>
                                    </thead>
                                    {summary.map((item, index) => (
                                        <tr key={index}>
                                            <td>Job No: {item.job_no}</td>
                                            {/* <td>{item.unit_of_quantity}</td> */}
                                            <td>{item.sales_unit_of_quantity}</td>
                                            <td>{item.sales_unit_of_rate}</td>
                                            <td>{item.sales_net_total}</td>
                                        </tr>
                                    ))}
                                    <tr className="total-row">
                                        <td>Total</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.sales_unit_of_quantity || 0), 0)}</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.sales_unit_of_rate || 0), 0)}</td>
                                        <td>{summary.reduce((sum, item) => sum + parseFloat(item.sales_net_total || 0), 0)}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <p style={{ margin: 0, fontSize: '12px', fontWeight: 600, fontFamily: 'Work Sans' }}>Backdated date</p>
                            <DatePicker
                                selected={backdatedDate ? new Date(backdatedDate) : null}
                                onChange={(date) => {
                                    const selectedDateStr = date?.toLocaleDateString('en-CA');
                                    if (!selectedDateStr || isDateEnabled(selectedDateStr)) {
                                        setBackdatedDate(selectedDateStr);
                                    } else {
                                        toast.error(`Only dates between ${minDate} and ${maxDate} are allowed`);
                                    }
                                }}
                                minDate={minDate ? new Date(minDate) : null}
                                maxDate={maxDate ? new Date(maxDate) : null}
                                placeholderText="Select a backdated date"
                                dateFormat="yyyy-MM-dd"
                                disabled={!isDraft}
                                className="custom-datepicker-input"
                                popperPlacement="bottom-start"
                            />
                        </div>
                    </div>
                </div>


                <div className="invoice_popup_categories">
                    {isSubmitted && (
                        <div className="invoice-module-wrapper">
                            <div className="invoice-module-button">
                                <button
                                    className={`edit_btn ${activeTab === 'jobs' ? 'active-tab' : ''}`}
                                    onClick={() => setActiveTab('jobs')}
                                >
                                    Jobs
                                </button>
                                <button
                                    className={`edit_btn ${activeTab === 'approval' ? 'active-tab' : ''}`}
                                    onClick={() => setActiveTab('approval')}
                                >
                                    Approval Flow
                                </button>
                            </div>

                            {/* <div>
                                <button
                                    className="consolidated-btn-viewpage"
                                    onClick={handleConsolidatedSalesAttachment}
                                >
                                    <HiOutlineDownload size={16} style={{ marginRight: "6px" }} />
                                    Consolidated Sales PDF
                                </button>
                            </div> */}
                        </div>
                    )}
                    {/* {isDraft && (
                        <p className="invoice-module-summary-summary">Jobs</p>
                    )} */}
                    {(activeTab === 'jobs') && (
                        <div>
                            {allCategories.map((category, index) => {
                                const totals = calculateCategoryTotals(category);
                                return (
                                    <div key={category.id} style={{ marginTop: '30px' }} className="invoice_popup_outercategory">
                                        <div className="invoice_popup_category_header">
                                            <div className="category_name_left">
                                                <span className="category_name">Job No: {category.jobnumber}</span>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                gap: "12px",
                                                fontSize: '12px',
                                                flexWrap: "wrap"
                                            }}>
                                                {/* SALES BOX */}
                                                <div style={{
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: "8px",
                                                    padding: "12px 16px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    width: 'auto',
                                                    height: '30px',
                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                                }}>
                                                    <span style={{ color: "green", fontWeight: "600" }}>SALES : </span>
                                                    <span style={{ color: "#000" }}>
                                                        Accrual : ₹ {category.rows.reduce((sum, row) => sum + (parseFloat(row.salesAccrual) || 0), 0).toLocaleString()}
                                                    </span>
                                                    <span style={{
                                                        width: "1px",
                                                        backgroundColor: "#ccc",
                                                        alignSelf: "stretch"
                                                    }}></span>
                                                    <span style={{ color: "#000" }}>
                                                        Net Total : ₹ {category.rows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0).toLocaleString()}
                                                    </span>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="invoice_popup_category_subheader">
                                            <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                                <div className="table-container">
                                                    <table className="invoice_table">
                                                        <thead>
                                                            <th colSpan="11" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F', textAlign: 'center' }}>
                                                                SALES
                                                            </th>
                                                            <tr>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>CHARGE CODE</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>DESCRIPTION</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>PO/WO NO</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>PO/WO Date</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>REMARKS</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>ACCRUAL SPLIT</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>CONTRACT VALUE</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>QUANTITY</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>RATE</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>NET TOTAL</th>
                                                                <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center', padding: '10px' }}>ATTACHMENT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {category.rows.map((row, lineindex) => (
                                                                <tr key={lineindex}>

                                                                    <td style={{ position: "relative" }}>
                                                                        <input
                                                                            style={{ margin: '0px' }}
                                                                            type="text"
                                                                            disabled={!isDraft}
                                                                            // value={inputValues[index]?.[lineindex] || ""}
                                                                            value={inputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                                                            onChange={(e) => {
                                                                                // console.log("canEditChargeDetailsssssssssss", canEditChargeDetails);
                                                                                // if (!canEditChargeDetails) return;
                                                                                const val = e.target.value;
                                                                                handleInputChange(e, index, lineindex, "chargecode");
                                                                                setInputValues((prev) => ({
                                                                                    ...prev,
                                                                                    [index]: {
                                                                                        ...prev[index],
                                                                                        [lineindex]: val,
                                                                                    },
                                                                                }));
                                                                                fetchSuggestions(val, lineindex, index);
                                                                            }}
                                                                            onFocus={() => {
                                                                                // if (!canEditChargeDetails) return;
                                                                                const list = suggestionsMap[index]?.[lineindex] || [];
                                                                                if (list.length > 0) {
                                                                                    const list = suggestionsMap[index]?.[lineindex] || [];
                                                                                    if (list.length > 0) {
                                                                                        setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                                                                    }
                                                                                }
                                                                            }}
                                                                            onBlur={() => {
                                                                                setTimeout(() => {
                                                                                    setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                                                                }, 200);
                                                                            }}
                                                                            className="invoice_small_input"
                                                                            placeholder="Search"
                                                                        // disabled={!canEditChargeDetails}
                                                                        />

                                                                        {showSuggestionsMap[`${index}_${lineindex}`] && suggestionsMap[index]?.[lineindex]?.length > 0 && (
                                                                            <ul
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "100%",
                                                                                    left: 0,
                                                                                    right: 0,
                                                                                    backgroundColor: "white",
                                                                                    border: "1px solid #ccc",
                                                                                    zIndex: 999,
                                                                                    maxHeight: "150px",
                                                                                    overflowY: "auto",
                                                                                    margin: 0,
                                                                                    padding: 0,
                                                                                    listStyle: "none",
                                                                                }}
                                                                            >
                                                                                {suggestionsMap[index]?.[lineindex].map((item) => (
                                                                                    <li
                                                                                        key={item.value}
                                                                                        onMouseDown={() => {
                                                                                            const selected = item.label;
                                                                                            const chargeId = item.value;
                                                                                            const supporting_doc = item.value1; // new


                                                                                            setInputValues((prev) => ({
                                                                                                ...prev,
                                                                                                [index]: {
                                                                                                    ...prev[index],
                                                                                                    [lineindex]: selected,
                                                                                                },
                                                                                            }));

                                                                                            setSelectedChargeIds((prev) => ({
                                                                                                ...prev,
                                                                                                [`${index}_${lineindex}`]: chargeId
                                                                                            }));

                                                                                            handleInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                                                            setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));


                                                                                            // ✨ NEW PART: split and set description separately ✨
                                                                                            const splitParts = selected.split("-");
                                                                                            const chargeCodeOnly = splitParts[0] || "";
                                                                                            const descriptionOnly = splitParts.slice(1).join("-") || "";


                                                                                            // Update charge code field value (CT002)
                                                                                            setInputValues((prev) => ({
                                                                                                ...prev,
                                                                                                [index]: {
                                                                                                    ...prev[index],
                                                                                                    [lineindex]: chargeCodeOnly,
                                                                                                },
                                                                                            }));

                                                                                            handleInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                                                                            // Update description field value (TestCharge)
                                                                                            handleInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");


                                                                                            // 🔥 Update supporting doc flag in that row
                                                                                            setAllCategories(prev =>
                                                                                                prev.map((cat, catIndex) =>
                                                                                                    catIndex === index
                                                                                                        ? {
                                                                                                            ...cat,
                                                                                                            rows: cat.rows.map((row, rIndex) =>
                                                                                                                rIndex === lineindex
                                                                                                                    ? { ...row, supporting_document: !!supporting_doc }
                                                                                                                    : row
                                                                                                            ),
                                                                                                        }
                                                                                                        : cat
                                                                                                )
                                                                                            );

                                                                                        }}
                                                                                        style={{
                                                                                            padding: "8px",
                                                                                            cursor: "pointer",
                                                                                            borderBottom: "1px solid #eee",
                                                                                        }}
                                                                                    >
                                                                                        {item.label}
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            value={row.description}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "description")}
                                                                            className="invoice_small_input"
                                                                            disabled={!isDraft}
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.po_wo_number}
                                                                            onInput={(e) => {
                                                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                                            }}
                                                                            onChange={(e) => {
                                                                                if (e.target.value.length <= 10) {
                                                                                    handleInputChange(e, index, lineindex, "po_wo_number");
                                                                                }
                                                                            }}
                                                                            className="invoice_narrow_input_quantity"
                                                                            disabled={!isDraft}
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="date"
                                                                            value={row.po_wo_date}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "po_wo_date")}
                                                                            className="invoice_narrow_input_quantity"
                                                                            disabled={!isDraft}
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                        />
                                                                    </td>

                                                                    {/* <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.unitQuantity}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                                                            className="invoice_small_input"
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td> */}
                                                                    {/* SALES REMARKS */}
                                                                    <td>
                                                                        <div
                                                                            className="table-tooltip-container"
                                                                            style={{ display: "flex", alignItems: "center", gap: "6px" }}
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                value={row.salesRemarks}
                                                                                onChange={(e) => {
                                                                                    handleInputChange(e, index, lineindex, "salesRemarks");
                                                                                }}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === ",") e.preventDefault();
                                                                                }}
                                                                                className="contracts_small_input"
                                                                                style={{ margin: "0px", fontFamily: "Work Sans" }}
                                                                                disabled={!isDraft}
                                                                            />

                                                                            {isDraft && row.salesRemarks?.trim() && (
                                                                                <SquarePen
                                                                                    size={16}
                                                                                    onClick={() =>
                                                                                        openRemarkPopup(index, lineindex, row.salesRemarks)
                                                                                    }
                                                                                />
                                                                            )}

                                                                            <span className="add-contract-tooltip">
                                                                                {row.salesRemarks}
                                                                            </span>
                                                                        </div>
                                                                    </td>

                                                                    {/* SALES accrualSplit */}
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.salesAccrual || 0}
                                                                            className="invoice_narrow_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            // readOnly
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    {/* SALES CONTRACT VALUE */}
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.salesContractValue}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "salesContractValue")}
                                                                            className="invoice_narrow_input"
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                            disabled
                                                                        />
                                                                    </td>
                                                                    {/* SALES QUANTITY */}
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.salesunitQuantity}
                                                                            onChange={(e) => handleInputChange(e, index, lineindex, "salesunitQuantity")}
                                                                            className="invoice_narrow_input_quantity"
                                                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                            disabled={!isDraft}
                                                                        />
                                                                    </td>
                                                                    {/* SALES RATE */}
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.salesRate}
                                                                            className="invoice_narrow_input"
                                                                            disabled={!isDraft}
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                            onChange={(e) => {
                                                                                handleInputChange(e, index, lineindex, "salesRate");
                                                                            }}

                                                                        />
                                                                    </td>
                                                                    {/* SALES NET TOTAL */}
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={row.salesNetTotal}
                                                                            // readOnly
                                                                            disabled={!isDraft}
                                                                            className="invoice_narrow_input"
                                                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div className="file_upload_wrapper">
                                                                            {/* Uploaded files */}
                                                                            {row.uploadedFiles && row.uploadedFiles.length > 0 && (
                                                                                <div className="uploaded_files">
                                                                                    {row.uploadedFiles.map((file, fileIndex) => (
                                                                                        <div key={fileIndex} className="uploaded_file_item">
                                                                                            <img
                                                                                                src={file.name.match(/\.(xls|xlsx)$/i) ? excel_icon : upload_icon}
                                                                                                alt="File"
                                                                                                className="file_icon"
                                                                                            />
                                                                                            <span className="file_name">{file.name}</span>
                                                                                            {isDraft && (
                                                                                                <button
                                                                                                    className="remove_file_btn"
                                                                                                    onClick={() => handleRemoveFile(category.id, index, lineindex, fileIndex)}
                                                                                                >
                                                                                                    ⨉
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}

                                                                            {/* Existing attachment from API */}
                                                                            {!row.uploadedFiles?.length && row.attachment && (
                                                                                <div className="attachment_view_section">
                                                                                    <a
                                                                                        href={row.attachment}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="view_link"
                                                                                    >
                                                                                        <i className="fa fa-eye" style={{ marginRight: "5px" }}></i>
                                                                                        <span className="view_text">View</span>
                                                                                    </a>
                                                                                    {isDraft && (
                                                                                        <button
                                                                                            className="remove_file_btn"
                                                                                            onClick={() => {
                                                                                                const updatedCategories = [...allCategories];
                                                                                                updatedCategories[index].rows[lineindex].attachment = null;
                                                                                                setAllCategories(updatedCategories);
                                                                                            }}
                                                                                        >
                                                                                            ⨉
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            )}

                                                                            {/* Upload option */}
                                                                            {isDraft && !row.uploadedFiles?.length && !row.attachment && (
                                                                                <label className="file_upload">
                                                                                    <input
                                                                                        type="file"
                                                                                        multiple
                                                                                        onChange={(e) => handleFileUpload(e, category.id, index, lineindex)}
                                                                                        style={{ display: "none" }}
                                                                                    />
                                                                                    <img src={upload_icon} alt="Upload" className="upload_icon" />
                                                                                    <span className="upload_text">Upload{" "}
                                                                                        {row.supporting_document && (
                                                                                            <span style={{ color: "red" }}>(Required*)</span>
                                                                                        )}</span>
                                                                                </label>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            position: 'sticky',
                                                                            right: 0,
                                                                            background: 'white',
                                                                            zIndex: 1,
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    >
                                                                        {/* <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}> */}
                                                                        {isDraft && (
                                                                            <button style={{ backgroundColor: 'white' }} onClick={() => deleteRow(category.id, lineindex)}>
                                                                                <img src={delete_icon} alt="Delete" className="delete_icon" />
                                                                            </button>
                                                                        )}
                                                                        {/* </AdditionalPermissionWrapper> */}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                    {/* <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}>
                                                        {isDraft && (
                                                            <div className="static-delete-container">
                                                                {category.rows.map((row, index) => (
                                                                    <div key={index} className="static-delete-btn">
                                                                        <button onClick={() => deleteRow(category.id, index)}>
                                                                            <img src={delete_icon} alt="Delete" className="delete_icon" />
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </AdditionalPermissionWrapper> */}
                                                </div>

                                                {/* <AdditionalPermissionWrapper permissionKey="edit_inv_line" moduleId={ModuleId}> */}
                                                {isDraft && (
                                                    <div
                                                        className="add_new_row"
                                                        onClick={() => addRow(category.id)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <span className="add_new_row_popup">
                                                            <img src={plus_icon} alt="" />
                                                            Add Row
                                                        </span>
                                                    </div>
                                                )}
                                                {/* </AdditionalPermissionWrapper> */}

                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                    {/* approval flow */}

                    {(activeTab === 'approval') && (

                        <div style={{ backgroundColor: '#F9FAFB', minHeight: 'auto' }}>
                            <div style={{
                                backgroundColor: '#fff',
                                marginTop: '30px',
                                borderRadius: '8px',
                                width: '100%',
                                height: '100%',
                                position: 'relative',

                            }}>
                                {/* Close Button */}
                                {/* <button
                                    onClick={() => setShowTimeline(false)}
                                    style={{
                                        position: 'absolute',
                                        top: '20px',
                                        right: '20px',
                                        background: '#F9FAFB',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '50%',
                                        width: '32px',
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '18px',
                                        color: '#1F2937',
                                        cursor: 'pointer',
                                    }}
                                >
                                    ×
                                </button> */}

                                {/* Title */}
                                <h2 style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    marginBottom: '24px',
                                    color: '#111827',
                                }}>
                                    History : {approvalHistory.length}
                                </h2>

                                {/* Timeline */}
                                <div style={{ position: 'relative', paddingLeft: '30px' }}>
                                    {/* Vertical Line */}
                                    <div style={{
                                        position: 'absolute',
                                        top: '24px',
                                        left: '14px',
                                        width: '1px',
                                        height: 'calc(100% - 24px)',
                                        backgroundImage: 'linear-gradient(#D1D5DB 33%, rgba(209, 213, 219, 0) 0%)',
                                        backgroundPosition: 'right',
                                        backgroundSize: '2px 10px',
                                        backgroundRepeat: 'repeat-y',
                                    }} />

                                    {approvalHistory.length === 0 ? (
                                        <div>
                                            No approval history available
                                        </div>
                                    ) : (
                                        approvalHistory.map((item, index) => {
                                            const status = item.status?.toLowerCase();
                                            return (
                                                <div key={index} style={{ marginBottom: '40px', position: 'relative' }}>
                                                    {/* Icon */}
                                                    <div style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        backgroundColor:
                                                            status === 'approved' ? '#C1F7D7' :
                                                                status === 'rejected' ? '#FECACA' :
                                                                    status === 'submitted' ? '#C1F7D7' :
                                                                        status === 'cancel submitted' ? '#FEF3C7' :
                                                                            status === 'deleted' ? '#FEE2E2' :
                                                                                '#E5E7EB',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        position: 'absolute',
                                                        left: '-30px',
                                                        top: '12px',
                                                    }}>
                                                        {status === 'approved' ? (
                                                            <img style={{ width: '20px' }} src={tick_icon} alt="Approved" />
                                                        ) : status === 'rejected' ? (
                                                            <span style={{ color: '#DC2626', fontWeight: 'bold', marginTop: '6px' }}>×</span>
                                                        ) : status === 'submitted' ? (
                                                            <img style={{ width: '40px' }} src={submitted_icon} alt="Submitted" />
                                                        ) : status === 'cancel submitted' ? (
                                                            <img style={{ width: '20px' }} src={cancel_icon} alt="cancel submitted" />
                                                        ) : status === 'deleted' ? (
                                                            <img style={{ width: '20px' }} src={deleted_icon} alt="Deleted" />
                                                        ) : (
                                                            <span style={{ color: '#4B5563' }}>...</span>
                                                        )}
                                                    </div>

                                                    {/* Content */}
                                                    <div style={{ marginLeft: '20px' }}>
                                                        <div style={{
                                                            fontWeight: '600',
                                                            fontSize: '15px',
                                                            color: '#19324C',
                                                            marginBottom: '4px',
                                                            textTransform: 'capitalize'
                                                        }}>
                                                            {item.status.toLowerCase() || 'Pending'}
                                                        </div>
                                                        <div style={{
                                                            fontSize: '14px',
                                                            color: '#19324C',
                                                            marginBottom: '2px',
                                                        }}>
                                                            {item.user_name || 'Unknown User'}
                                                        </div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            color: '#9CA3AF'
                                                        }}>
                                                            {item.date_time || 'No date available'}
                                                        </div>
                                                        {item.comments && (
                                                            <div style={{
                                                                fontSize: '14px',
                                                                color: '#4B5563',
                                                                marginTop: '8px',
                                                                fontStyle: 'italic'
                                                            }}>
                                                                Comments: {item.comments}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {ismodalOpen && (
                <div className="modal" onClick={() => setIsModalOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h3>Remarks to Customer</h3>
                        <SapCsvSafeInput
                            as="textarea"
                            value={salesHeaderRemarks}
                            onChange={setSalesHeaderRemarks}
                            maxLength={255}
                            placeholder="Enter your Sales Remarks..."
                        />
                        <p style={{ fontSize: "12px", textAlign: "right", color: "#555" }}>
                            {salesHeaderRemarks.length}/255
                        </p>

                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                                flexWrap: "wrap",
                                marginTop: "5px",
                            }}
                        >
                            {/* Billing Nature */}
                            <div style={{ flex: "1 1 45%" }}>
                                <label
                                    style={{
                                        display: "block",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        fontFamily: "Work Sans",
                                        color: "#19324C",
                                    }}
                                >
                                    Billing Nature
                                </label>
                                <SapCsvSafeInput
                                    value={billingNature}
                                    onChange={setBillingNature}
                                    maxLength={18}
                                    placeholder="Enter Billing Nature"
                                    style={{
                                        width: "100%",
                                        height: "33px",
                                        padding: "6px 8px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontFamily: "Work Sans",
                                        margin: "0px"
                                    }}
                                />
                                <p style={{ fontSize: "11px", textAlign: "right", color: "#777" }}>
                                    {billingNature?.length || 0}/18
                                </p>
                            </div>

                            {/* Supply Period */}
                            <div style={{ flex: "1 1 45%" }}>
                                <label
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        fontFamily: "Work Sans",
                                        color: "#19324C",
                                    }}
                                >
                                    Supply Period
                                </label>
                                <DatePicker
                                    selected={supplyPeriod}
                                    onChange={(date) => setSupplyPeriod(date)}
                                    dateFormat="MMM-yyyy"
                                    showMonthYearPicker
                                    className="generate-sales-custom-datepicker-input"
                                    placeholderText="Select month & year"
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="modal-buttons">
                            <button onClick={() => setIsModalOpen(false)}>Cancel</button>
                            <button onClick={() => {
                                setIsModalOpen(false);
                                handleUpdate("submit");
                            }} disabled={isSaving || isSubmitting}>
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <CommonRemarkPopup
                show={showRemarkPopup}
                onClose={() => setShowRemarkPopup(false)}
                onSave={handleSaveRemark}
                initialValue={remarkValue}
                title="Sales Remarks"
            />
            {isModalOpen && approvalData && (
                <ApproveRejectPopup
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    actionType={actionType}
                    invoice={{ approvalData }}
                    onSubmit={(data) => handleInvoiceAction(data)}
                    isLoading={isApproveLoading}
                />
            )}
            <CommonFooter />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default SalesInvoiceViewPage
